
import { Dialog, Portal } from '@chakra-ui/react'

export const AlertDialog = ({ title, isOpen, onClose, footer, children, ...props }) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={(e) => onClose(e.open)} role="alertdialog" {...props}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header fontSize="lg" fontWeight="bold">
              <Dialog.Title>{title}</Dialog.Title>
            </Dialog.Header>

            <Dialog.Body>{children}</Dialog.Body>

            <Dialog.Footer mb="8px">{footer}</Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
